module.exports = __webpack_public_path__ + "img/mau1-3-nhan-104x22mm.5e8ead63.jpg";